<div class="em-settings-tasklaucher">
    <router-outlet></router-outlet>
</div>